/* eslint-disable jira/filename-case */
import type { MouseEvent, KeyboardEvent } from 'react';

export const isNormalClick = (e: MouseEvent | KeyboardEvent): boolean =>
	!(('button' in e && e.button) || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
